import { environment } from 'src/environments/environment';
import { BaseHttpService } from "./base.http.service";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthFacade } from 'src/app/store/auth/facade/auth.facade';
import { tap } from 'rxjs/operators';
import { Observable, of, Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { IEnvironmentConfig } from 'src/app/models/environmentConfig';

@Injectable()
export class PermissionsService extends BaseHttpService {
    private permissionsCache: Map<string, boolean>;
    private isUserLoggedIn: Subscription;

    constructor(
        private httpClient: HttpClient,
        private authFacade: AuthFacade,
        private appConfig: AppConfig,
    ) {
        super();
        this.permissionsCache = new Map<string, boolean>();
        this.isUserLoggedIn = this.authFacade.userLoggedIn$()
            .subscribe(isUserLoggedIn => {
                if (!isUserLoggedIn) {
                    this.permissionsCache = new Map<string, boolean>();
                }
            });
    }

    get envSettings(): IEnvironmentConfig {
        return this.appConfig.getEnvironmentConfig();
    }


    public hasPermission(action: string, entityId?: number, portfolioId?: number): Observable<boolean> {
        // Create the URL
        let url = `${this.envSettings.webApiUrl}permissions/hasPermission?action=${action}`;
        if (entityId) {
            url += `&entityId=${entityId}`;
        }
        if (portfolioId) {
            url += `&portfolioId=${portfolioId}`;
        }

        // Check for permission with the server. If we have a result cached, return that instead
        if (this.permissionsCache.has(url)) {
            return of(this.permissionsCache.get(url));
        } else {
            return this.httpClient.get<boolean>(url, {
                observe: "body",
                responseType: "json",
                headers: this.getHttpHeaders()
            })
                .pipe(
                    tap(res => {
                        // Cache the result
                        this.permissionsCache.set(url, res);
                    }));
        }
    }

    public hasPermissionCheckMultiple(action: string, entityIds: number[]): Observable<any> {

        if(entityIds === null || entityIds === undefined || entityIds.length === 0)
            return;

        // Create the URL
        let entityIdsJoined = entityIds.join('&entityIds=')
        let url = `${this.envSettings.webApiUrl}permissions/hasPermission/multiple?action=${action}&entityIds=${entityIdsJoined}`;

        return this.httpClient.get(url.toString(), {
            observe: "body",
            responseType: "json",
            headers: this.getHttpHeaders()
        })
    }
}

export interface PermissionResult
{
    entityId? : number,
    portfolioId? : number,
    managerId?: number,
    hasPermission: boolean,
    permissionAction: string
}